import VehicleCoverage from 'models/VehicleCoverage'

class VehicleCluster {
    constructor(id, name, coverage = null) {
        this.id = id
        this.name = name
        this.coverage = coverage
    }

    setCoverage(coverage) {
        this.coverage = coverage
    }

    static fromGroupedCoverageItem(insuranceCompany, item) {
        return new VehicleCluster(
            item.clusterCode,
            null,
            VehicleCoverage.fromGroupedItem(insuranceCompany, item)
        )
    }
}

export default VehicleCluster
